/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddImageRateCommandResult } from '../models/add-image-rate-command-result';
import { AddImageRateToNoteReplyCommandResult } from '../models/add-image-rate-to-note-reply-command-result';
import { AddNotesCommandResult } from '../models/add-notes-command-result';
import { AddReplyCommandResult } from '../models/add-reply-command-result';
import { apiKpiReportsAddImageRateToNotePost } from '../fn/kpi-reports/api-kpi-reports-add-image-rate-to-note-post';
import { ApiKpiReportsAddImageRateToNotePost$Params } from '../fn/kpi-reports/api-kpi-reports-add-image-rate-to-note-post';
import { apiKpiReportsAddImageRateToNotePost$Plain } from '../fn/kpi-reports/api-kpi-reports-add-image-rate-to-note-post-plain';
import { ApiKpiReportsAddImageRateToNotePost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-add-image-rate-to-note-post-plain';
import { apiKpiReportsAddImageRateToReplyNotePost } from '../fn/kpi-reports/api-kpi-reports-add-image-rate-to-reply-note-post';
import { ApiKpiReportsAddImageRateToReplyNotePost$Params } from '../fn/kpi-reports/api-kpi-reports-add-image-rate-to-reply-note-post';
import { apiKpiReportsAddImageRateToReplyNotePost$Plain } from '../fn/kpi-reports/api-kpi-reports-add-image-rate-to-reply-note-post-plain';
import { ApiKpiReportsAddImageRateToReplyNotePost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-add-image-rate-to-reply-note-post-plain';
import { apiKpiReportsAddNotePost } from '../fn/kpi-reports/api-kpi-reports-add-note-post';
import { ApiKpiReportsAddNotePost$Params } from '../fn/kpi-reports/api-kpi-reports-add-note-post';
import { apiKpiReportsAddNotePost$Plain } from '../fn/kpi-reports/api-kpi-reports-add-note-post-plain';
import { ApiKpiReportsAddNotePost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-add-note-post-plain';
import { apiKpiReportsAddReplyPost } from '../fn/kpi-reports/api-kpi-reports-add-reply-post';
import { ApiKpiReportsAddReplyPost$Params } from '../fn/kpi-reports/api-kpi-reports-add-reply-post';
import { apiKpiReportsAddReplyPost$Plain } from '../fn/kpi-reports/api-kpi-reports-add-reply-post-plain';
import { ApiKpiReportsAddReplyPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-add-reply-post-plain';
import { apiKpiReportsApplyPenaltyPost } from '../fn/kpi-reports/api-kpi-reports-apply-penalty-post';
import { ApiKpiReportsApplyPenaltyPost$Params } from '../fn/kpi-reports/api-kpi-reports-apply-penalty-post';
import { apiKpiReportsApplyPenaltyPost$Plain } from '../fn/kpi-reports/api-kpi-reports-apply-penalty-post-plain';
import { ApiKpiReportsApplyPenaltyPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-apply-penalty-post-plain';
import { apiKpiReportsChangeKpiStatusPost } from '../fn/kpi-reports/api-kpi-reports-change-kpi-status-post';
import { ApiKpiReportsChangeKpiStatusPost$Params } from '../fn/kpi-reports/api-kpi-reports-change-kpi-status-post';
import { apiKpiReportsChangeKpiStatusPost$Plain } from '../fn/kpi-reports/api-kpi-reports-change-kpi-status-post-plain';
import { ApiKpiReportsChangeKpiStatusPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-change-kpi-status-post-plain';
import { apiKpiReportsChangeNoteStatusPost } from '../fn/kpi-reports/api-kpi-reports-change-note-status-post';
import { ApiKpiReportsChangeNoteStatusPost$Params } from '../fn/kpi-reports/api-kpi-reports-change-note-status-post';
import { apiKpiReportsChangeNoteStatusPost$Plain } from '../fn/kpi-reports/api-kpi-reports-change-note-status-post-plain';
import { ApiKpiReportsChangeNoteStatusPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-change-note-status-post-plain';
import { apiKpiReportsDeservesPenaltyPost } from '../fn/kpi-reports/api-kpi-reports-deserves-penalty-post';
import { ApiKpiReportsDeservesPenaltyPost$Params } from '../fn/kpi-reports/api-kpi-reports-deserves-penalty-post';
import { apiKpiReportsDeservesPenaltyPost$Plain } from '../fn/kpi-reports/api-kpi-reports-deserves-penalty-post-plain';
import { ApiKpiReportsDeservesPenaltyPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-deserves-penalty-post-plain';
import { apiKpiReportsGetReplyChildsPost } from '../fn/kpi-reports/api-kpi-reports-get-reply-childs-post';
import { ApiKpiReportsGetReplyChildsPost$Params } from '../fn/kpi-reports/api-kpi-reports-get-reply-childs-post';
import { apiKpiReportsGetReplyChildsPost$Plain } from '../fn/kpi-reports/api-kpi-reports-get-reply-childs-post-plain';
import { ApiKpiReportsGetReplyChildsPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-get-reply-childs-post-plain';
import { apiKpiReportsSelectOptionPost } from '../fn/kpi-reports/api-kpi-reports-select-option-post';
import { ApiKpiReportsSelectOptionPost$Params } from '../fn/kpi-reports/api-kpi-reports-select-option-post';
import { apiKpiReportsSelectOptionPost$Plain } from '../fn/kpi-reports/api-kpi-reports-select-option-post-plain';
import { ApiKpiReportsSelectOptionPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-select-option-post-plain';
import { apiKpiReportsUpdateKpiReportsPost } from '../fn/kpi-reports/api-kpi-reports-update-kpi-reports-post';
import { ApiKpiReportsUpdateKpiReportsPost$Params } from '../fn/kpi-reports/api-kpi-reports-update-kpi-reports-post';
import { apiKpiReportsUpdateKpiReportsPost$Plain } from '../fn/kpi-reports/api-kpi-reports-update-kpi-reports-post-plain';
import { ApiKpiReportsUpdateKpiReportsPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-update-kpi-reports-post-plain';
import { apiKpiReportsUpdateNotePost } from '../fn/kpi-reports/api-kpi-reports-update-note-post';
import { ApiKpiReportsUpdateNotePost$Params } from '../fn/kpi-reports/api-kpi-reports-update-note-post';
import { apiKpiReportsUpdateNotePost$Plain } from '../fn/kpi-reports/api-kpi-reports-update-note-post-plain';
import { ApiKpiReportsUpdateNotePost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-update-note-post-plain';
import { apiKpiReportsUpdateReplyPost } from '../fn/kpi-reports/api-kpi-reports-update-reply-post';
import { ApiKpiReportsUpdateReplyPost$Params } from '../fn/kpi-reports/api-kpi-reports-update-reply-post';
import { apiKpiReportsUpdateReplyPost$Plain } from '../fn/kpi-reports/api-kpi-reports-update-reply-post-plain';
import { ApiKpiReportsUpdateReplyPost$Plain$Params } from '../fn/kpi-reports/api-kpi-reports-update-reply-post-plain';
import { ApplyPenaltyCommandResult } from '../models/apply-penalty-command-result';
import { ChangeKpiStatusCommandResult } from '../models/change-kpi-status-command-result';
import { ChangeNoteStatusCommandResult } from '../models/change-note-status-command-result';
import { DeservesPenaltyCommandResult } from '../models/deserves-penalty-command-result';
import { GetReplyChildsQueryResult } from '../models/get-reply-childs-query-result';
import { SelectOptionCommandResult } from '../models/select-option-command-result';
import { UpdateKpiReportCommandResult } from '../models/update-kpi-report-command-result';
import { UpdateNoteCommandResult } from '../models/update-note-command-result';
import { UpdateReplyCommandResult } from '../models/update-reply-command-result';

@Injectable({ providedIn: 'root' })
export class KpiReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiKpiReportsGetReplyChildsPost()` */
  static readonly ApiKpiReportsGetReplyChildsPostPath = '/api/KPIReports/GetReplyChilds';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsGetReplyChildsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsGetReplyChildsPost$Plain$Response(params?: ApiKpiReportsGetReplyChildsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetReplyChildsQueryResult>> {
    return apiKpiReportsGetReplyChildsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsGetReplyChildsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsGetReplyChildsPost$Plain(params?: ApiKpiReportsGetReplyChildsPost$Plain$Params, context?: HttpContext): Observable<GetReplyChildsQueryResult> {
    return this.apiKpiReportsGetReplyChildsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetReplyChildsQueryResult>): GetReplyChildsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsGetReplyChildsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsGetReplyChildsPost$Response(params?: ApiKpiReportsGetReplyChildsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetReplyChildsQueryResult>> {
    return apiKpiReportsGetReplyChildsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsGetReplyChildsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsGetReplyChildsPost(params?: ApiKpiReportsGetReplyChildsPost$Params, context?: HttpContext): Observable<GetReplyChildsQueryResult> {
    return this.apiKpiReportsGetReplyChildsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetReplyChildsQueryResult>): GetReplyChildsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsAddNotePost()` */
  static readonly ApiKpiReportsAddNotePostPath = '/api/KPIReports/AddNote';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsAddNotePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsAddNotePost$Plain$Response(params?: ApiKpiReportsAddNotePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddNotesCommandResult>> {
    return apiKpiReportsAddNotePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsAddNotePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsAddNotePost$Plain(params?: ApiKpiReportsAddNotePost$Plain$Params, context?: HttpContext): Observable<AddNotesCommandResult> {
    return this.apiKpiReportsAddNotePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddNotesCommandResult>): AddNotesCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsAddNotePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsAddNotePost$Response(params?: ApiKpiReportsAddNotePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddNotesCommandResult>> {
    return apiKpiReportsAddNotePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsAddNotePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsAddNotePost(params?: ApiKpiReportsAddNotePost$Params, context?: HttpContext): Observable<AddNotesCommandResult> {
    return this.apiKpiReportsAddNotePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddNotesCommandResult>): AddNotesCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsUpdateNotePost()` */
  static readonly ApiKpiReportsUpdateNotePostPath = '/api/KPIReports/UpdateNote';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsUpdateNotePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsUpdateNotePost$Plain$Response(params?: ApiKpiReportsUpdateNotePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateNoteCommandResult>> {
    return apiKpiReportsUpdateNotePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsUpdateNotePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsUpdateNotePost$Plain(params?: ApiKpiReportsUpdateNotePost$Plain$Params, context?: HttpContext): Observable<UpdateNoteCommandResult> {
    return this.apiKpiReportsUpdateNotePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateNoteCommandResult>): UpdateNoteCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsUpdateNotePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsUpdateNotePost$Response(params?: ApiKpiReportsUpdateNotePost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateNoteCommandResult>> {
    return apiKpiReportsUpdateNotePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsUpdateNotePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsUpdateNotePost(params?: ApiKpiReportsUpdateNotePost$Params, context?: HttpContext): Observable<UpdateNoteCommandResult> {
    return this.apiKpiReportsUpdateNotePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateNoteCommandResult>): UpdateNoteCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsAddImageRateToNotePost()` */
  static readonly ApiKpiReportsAddImageRateToNotePostPath = '/api/KPIReports/AddImageRateToNote';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsAddImageRateToNotePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsAddImageRateToNotePost$Plain$Response(params?: ApiKpiReportsAddImageRateToNotePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddImageRateCommandResult>> {
    return apiKpiReportsAddImageRateToNotePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsAddImageRateToNotePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsAddImageRateToNotePost$Plain(params?: ApiKpiReportsAddImageRateToNotePost$Plain$Params, context?: HttpContext): Observable<AddImageRateCommandResult> {
    return this.apiKpiReportsAddImageRateToNotePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddImageRateCommandResult>): AddImageRateCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsAddImageRateToNotePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsAddImageRateToNotePost$Response(params?: ApiKpiReportsAddImageRateToNotePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddImageRateCommandResult>> {
    return apiKpiReportsAddImageRateToNotePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsAddImageRateToNotePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsAddImageRateToNotePost(params?: ApiKpiReportsAddImageRateToNotePost$Params, context?: HttpContext): Observable<AddImageRateCommandResult> {
    return this.apiKpiReportsAddImageRateToNotePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddImageRateCommandResult>): AddImageRateCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsAddImageRateToReplyNotePost()` */
  static readonly ApiKpiReportsAddImageRateToReplyNotePostPath = '/api/KPIReports/AddImageRateToReplyNote';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsAddImageRateToReplyNotePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsAddImageRateToReplyNotePost$Plain$Response(params?: ApiKpiReportsAddImageRateToReplyNotePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddImageRateToNoteReplyCommandResult>> {
    return apiKpiReportsAddImageRateToReplyNotePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsAddImageRateToReplyNotePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsAddImageRateToReplyNotePost$Plain(params?: ApiKpiReportsAddImageRateToReplyNotePost$Plain$Params, context?: HttpContext): Observable<AddImageRateToNoteReplyCommandResult> {
    return this.apiKpiReportsAddImageRateToReplyNotePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddImageRateToNoteReplyCommandResult>): AddImageRateToNoteReplyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsAddImageRateToReplyNotePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsAddImageRateToReplyNotePost$Response(params?: ApiKpiReportsAddImageRateToReplyNotePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddImageRateToNoteReplyCommandResult>> {
    return apiKpiReportsAddImageRateToReplyNotePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsAddImageRateToReplyNotePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsAddImageRateToReplyNotePost(params?: ApiKpiReportsAddImageRateToReplyNotePost$Params, context?: HttpContext): Observable<AddImageRateToNoteReplyCommandResult> {
    return this.apiKpiReportsAddImageRateToReplyNotePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddImageRateToNoteReplyCommandResult>): AddImageRateToNoteReplyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsAddReplyPost()` */
  static readonly ApiKpiReportsAddReplyPostPath = '/api/KPIReports/AddReply';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsAddReplyPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsAddReplyPost$Plain$Response(params?: ApiKpiReportsAddReplyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddReplyCommandResult>> {
    return apiKpiReportsAddReplyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsAddReplyPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsAddReplyPost$Plain(params?: ApiKpiReportsAddReplyPost$Plain$Params, context?: HttpContext): Observable<AddReplyCommandResult> {
    return this.apiKpiReportsAddReplyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddReplyCommandResult>): AddReplyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsAddReplyPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsAddReplyPost$Response(params?: ApiKpiReportsAddReplyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddReplyCommandResult>> {
    return apiKpiReportsAddReplyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsAddReplyPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsAddReplyPost(params?: ApiKpiReportsAddReplyPost$Params, context?: HttpContext): Observable<AddReplyCommandResult> {
    return this.apiKpiReportsAddReplyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddReplyCommandResult>): AddReplyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsUpdateReplyPost()` */
  static readonly ApiKpiReportsUpdateReplyPostPath = '/api/KPIReports/UpdateReply';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsUpdateReplyPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsUpdateReplyPost$Plain$Response(params?: ApiKpiReportsUpdateReplyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateReplyCommandResult>> {
    return apiKpiReportsUpdateReplyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsUpdateReplyPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsUpdateReplyPost$Plain(params?: ApiKpiReportsUpdateReplyPost$Plain$Params, context?: HttpContext): Observable<UpdateReplyCommandResult> {
    return this.apiKpiReportsUpdateReplyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateReplyCommandResult>): UpdateReplyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsUpdateReplyPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsUpdateReplyPost$Response(params?: ApiKpiReportsUpdateReplyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateReplyCommandResult>> {
    return apiKpiReportsUpdateReplyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsUpdateReplyPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsUpdateReplyPost(params?: ApiKpiReportsUpdateReplyPost$Params, context?: HttpContext): Observable<UpdateReplyCommandResult> {
    return this.apiKpiReportsUpdateReplyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateReplyCommandResult>): UpdateReplyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsDeservesPenaltyPost()` */
  static readonly ApiKpiReportsDeservesPenaltyPostPath = '/api/KPIReports/DeservesPenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsDeservesPenaltyPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsDeservesPenaltyPost$Plain$Response(params?: ApiKpiReportsDeservesPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeservesPenaltyCommandResult>> {
    return apiKpiReportsDeservesPenaltyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsDeservesPenaltyPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsDeservesPenaltyPost$Plain(params?: ApiKpiReportsDeservesPenaltyPost$Plain$Params, context?: HttpContext): Observable<DeservesPenaltyCommandResult> {
    return this.apiKpiReportsDeservesPenaltyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeservesPenaltyCommandResult>): DeservesPenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsDeservesPenaltyPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsDeservesPenaltyPost$Response(params?: ApiKpiReportsDeservesPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DeservesPenaltyCommandResult>> {
    return apiKpiReportsDeservesPenaltyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsDeservesPenaltyPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpiReportsDeservesPenaltyPost(params?: ApiKpiReportsDeservesPenaltyPost$Params, context?: HttpContext): Observable<DeservesPenaltyCommandResult> {
    return this.apiKpiReportsDeservesPenaltyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeservesPenaltyCommandResult>): DeservesPenaltyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsChangeKpiStatusPost()` */
  static readonly ApiKpiReportsChangeKpiStatusPostPath = '/api/KPIReports/ChangeKPIStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsChangeKpiStatusPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsChangeKpiStatusPost$Plain$Response(params?: ApiKpiReportsChangeKpiStatusPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeKpiStatusCommandResult>> {
    return apiKpiReportsChangeKpiStatusPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsChangeKpiStatusPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsChangeKpiStatusPost$Plain(params?: ApiKpiReportsChangeKpiStatusPost$Plain$Params, context?: HttpContext): Observable<ChangeKpiStatusCommandResult> {
    return this.apiKpiReportsChangeKpiStatusPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeKpiStatusCommandResult>): ChangeKpiStatusCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsChangeKpiStatusPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsChangeKpiStatusPost$Response(params?: ApiKpiReportsChangeKpiStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeKpiStatusCommandResult>> {
    return apiKpiReportsChangeKpiStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsChangeKpiStatusPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsChangeKpiStatusPost(params?: ApiKpiReportsChangeKpiStatusPost$Params, context?: HttpContext): Observable<ChangeKpiStatusCommandResult> {
    return this.apiKpiReportsChangeKpiStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeKpiStatusCommandResult>): ChangeKpiStatusCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsChangeNoteStatusPost()` */
  static readonly ApiKpiReportsChangeNoteStatusPostPath = '/api/KPIReports/ChangeNoteStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsChangeNoteStatusPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsChangeNoteStatusPost$Plain$Response(params?: ApiKpiReportsChangeNoteStatusPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeNoteStatusCommandResult>> {
    return apiKpiReportsChangeNoteStatusPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsChangeNoteStatusPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsChangeNoteStatusPost$Plain(params?: ApiKpiReportsChangeNoteStatusPost$Plain$Params, context?: HttpContext): Observable<ChangeNoteStatusCommandResult> {
    return this.apiKpiReportsChangeNoteStatusPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeNoteStatusCommandResult>): ChangeNoteStatusCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsChangeNoteStatusPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsChangeNoteStatusPost$Response(params?: ApiKpiReportsChangeNoteStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeNoteStatusCommandResult>> {
    return apiKpiReportsChangeNoteStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsChangeNoteStatusPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsChangeNoteStatusPost(params?: ApiKpiReportsChangeNoteStatusPost$Params, context?: HttpContext): Observable<ChangeNoteStatusCommandResult> {
    return this.apiKpiReportsChangeNoteStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeNoteStatusCommandResult>): ChangeNoteStatusCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsApplyPenaltyPost()` */
  static readonly ApiKpiReportsApplyPenaltyPostPath = '/api/KPIReports/ApplyPenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsApplyPenaltyPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsApplyPenaltyPost$Plain$Response(params?: ApiKpiReportsApplyPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplyPenaltyCommandResult>> {
    return apiKpiReportsApplyPenaltyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsApplyPenaltyPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsApplyPenaltyPost$Plain(params?: ApiKpiReportsApplyPenaltyPost$Plain$Params, context?: HttpContext): Observable<ApplyPenaltyCommandResult> {
    return this.apiKpiReportsApplyPenaltyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplyPenaltyCommandResult>): ApplyPenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsApplyPenaltyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsApplyPenaltyPost$Response(params?: ApiKpiReportsApplyPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplyPenaltyCommandResult>> {
    return apiKpiReportsApplyPenaltyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsApplyPenaltyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsApplyPenaltyPost(params?: ApiKpiReportsApplyPenaltyPost$Params, context?: HttpContext): Observable<ApplyPenaltyCommandResult> {
    return this.apiKpiReportsApplyPenaltyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApplyPenaltyCommandResult>): ApplyPenaltyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsSelectOptionPost()` */
  static readonly ApiKpiReportsSelectOptionPostPath = '/api/KPIReports/SelectOption';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsSelectOptionPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsSelectOptionPost$Plain$Response(params?: ApiKpiReportsSelectOptionPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectOptionCommandResult>> {
    return apiKpiReportsSelectOptionPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsSelectOptionPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsSelectOptionPost$Plain(params?: ApiKpiReportsSelectOptionPost$Plain$Params, context?: HttpContext): Observable<SelectOptionCommandResult> {
    return this.apiKpiReportsSelectOptionPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SelectOptionCommandResult>): SelectOptionCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsSelectOptionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsSelectOptionPost$Response(params?: ApiKpiReportsSelectOptionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectOptionCommandResult>> {
    return apiKpiReportsSelectOptionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsSelectOptionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsSelectOptionPost(params?: ApiKpiReportsSelectOptionPost$Params, context?: HttpContext): Observable<SelectOptionCommandResult> {
    return this.apiKpiReportsSelectOptionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SelectOptionCommandResult>): SelectOptionCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpiReportsUpdateKpiReportsPost()` */
  static readonly ApiKpiReportsUpdateKpiReportsPostPath = '/api/KPIReports/UpdateKPIReports';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsUpdateKpiReportsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsUpdateKpiReportsPost$Plain$Response(params?: ApiKpiReportsUpdateKpiReportsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateKpiReportCommandResult>> {
    return apiKpiReportsUpdateKpiReportsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsUpdateKpiReportsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsUpdateKpiReportsPost$Plain(params?: ApiKpiReportsUpdateKpiReportsPost$Plain$Params, context?: HttpContext): Observable<UpdateKpiReportCommandResult> {
    return this.apiKpiReportsUpdateKpiReportsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateKpiReportCommandResult>): UpdateKpiReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpiReportsUpdateKpiReportsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsUpdateKpiReportsPost$Response(params?: ApiKpiReportsUpdateKpiReportsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateKpiReportCommandResult>> {
    return apiKpiReportsUpdateKpiReportsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpiReportsUpdateKpiReportsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpiReportsUpdateKpiReportsPost(params?: ApiKpiReportsUpdateKpiReportsPost$Params, context?: HttpContext): Observable<UpdateKpiReportCommandResult> {
    return this.apiKpiReportsUpdateKpiReportsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateKpiReportCommandResult>): UpdateKpiReportCommandResult => r.body)
    );
  }

}
